import axios from 'axios';

import { fdApiUse } from '../apiUtils';
import { AppConfig } from './whitelabel.types';

// #region get requests
export const getAppConfig = (): Promise<AppConfig> =>
  fdApiUse(axios.get('/Account/AppConfig')).then((data: AppConfig) => data);
// #endregion
